module.exports = __webpack_public_path__ + "img/callme.b3a0c593.png";